import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Container, Row, Col, Card, CardHeader, Modal, Form, ModalBody, ModalFooter, ModalHeader, Label, Input, FormFeedback, ListGroup, ListGroupItem, Button } from '@/Components/ui';
;
//Import Breadcrumb
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
// import TableContainer from "../../../Components/Common/TableContainer";
import { Toaster } from 'react-hot-toast';
import Loader from "../../../Components/Common/Loader";
import { API_SUPPLY_ITEM_LIST, getDataFromUrl, BACKEND_HOST, API } from "../../../api";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { read, utils, writeFileXLSX, writeFile } from 'xlsx';
import QueryString from "qs";
import { dialogService } from "@/utils/dialogService";
const STATE_MODAL_FOCUS = {
    0: "사용처리",
    1: "사용취소",
};
const SupplyList = () => {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const [dataQuery, setDataQuery] = React.useState({});
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => { console.log(e); });
    };
    React.useEffect(() => {
        if (!previous && !next) {
            getDataFromUrl(API_SUPPLY_ITEM_LIST)
                .then((data) => {
                // console.log(data);
                setData(data.results);
                setPrevious(data.previous);
                setNext(data.next);
                setCount(data.count);
            })
                .catch((e) => { console.log(e); });
        }
    }, []);
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [stateChangeModal, setStateChangeModal] = React.useState(false);
    const [focusState, setFocusState] = React.useState(-1); // 0 : "사용처리", 1 : "사용취소"
    const [deleteModal, setDeleteModal] = useState(false);
    // const [deleteModalMulti, setDeleteModalMulti] = useState(false);
    const togStateChangeModal = () => setStateChangeModal(!stateChangeModal);
    const togDeleteModal = () => setDeleteModal(!deleteModal);
    const columns = React.useMemo(() => [
        {
            Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()}/>,
            Cell: (cellProps) => {
                return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id}/>;
            },
            id: '#',
        },
        {
            Header: 'ID',
            accessor: 'id',
            id: 'id',
        },
        {
            Header: '이미지',
            accessor: 'thumbnail',
            id: 'thumbnail',
            Cell: (cellProps) => {
                return <img src={`${cellProps.row.original["supply_product"]["thumbnail"]}`} width="50" height="50"/>;
            }
        },
        {
            Header: '상품명',
            accessor: 'name',
            id: 'name',
            Cell: (cellProps) => {
                return <span>{cellProps.row.original["supply_product"]["name"]}</span>;
            }
        },
        {
            Header: '가격',
            accessor: 'price',
            id: 'price',
            Cell: (cellProps) => {
                return <span>{cellProps.row.original["supply_product"]["price"]}</span>;
            }
        },
        {
            Header: '상태',
            accessor: 'state',
            id: 'state',
            Cell: (cellProps) => {
                const delivery = cellProps.row.original["delivery"];
                return <>
						{delivery ?
                        <span>{delivery["state"]}</span>
                        : <span>{cellProps.row.original["state"]}</span>}
					</>;
            }
        },
        {
            Header: '수량',
            accessor: 'quantity',
            id: 'quantity',
        },
        {
            Header: '주문일시',
            accessor: 'created_at',
            id: 'created_at',
            Cell: (cellProps) => {
                return <span>{cellProps.row.original["created_at"] !== "-" ? moment(cellProps.row.original["created_at"]).format("YYYY-MM-DD HH:mm") : ""}</span>;
            }
        },
        {
            Header: 'Actions',
            accessor: 'Actions',
            id: '',
            Cell: (cellProps) => {
                const delivery = cellProps.row.original["delivery"];
                if (delivery) {
                    return <></>;
                }
                return (<div className="d-flex gap-2">
							{/* {(cellProps.row.original["상태"] !== "사용함") && <div className="edit">
                        <div className="text" style={{ cursor: "pointer", color: "#3577f1" }} onClick={() => {
                            setCheckedRecords([cellProps.row.original]);
                            togStateChangeModal(); setFocusState(0)
                        }}>
                            <i className="ri-pencil-fill fs-16"></i>
                        </div>
                    </div>}
                    {(cellProps.row.original["상태"] !== "사용안함") && <div className="edit">
                        <div className="text" style={{ cursor: "pointer", color: "#ffbe0b" }} onClick={() => {
                            setCheckedRecords([cellProps.row.original]);
                            togStateChangeModal(); setFocusState(1)
                        }}>
                            <i className="ri-pencil-fill fs-16"></i>
                        </div>
                    </div>} */}
							<div className="remove">
								<div className="text-danger" style={{ cursor: "pointer" }} onClick={async () => {
                        if (await dialogService.confirm("정말 취소하시겠습니까?") === false)
                            return;
                        let item_id = cellProps.row.original.id;
                        let order_id = cellProps.row.original.order_id;
                        API.post(`${BACKEND_HOST}/supply/order-cancel/`, {
                            order_id: order_id,
                            partial_cancels: [
                                { id: item_id }
                            ]
                        })
                            .then((response) => {
                            console.log("order-cancel", response);
                            onRequestData(API_SUPPLY_ITEM_LIST);
                        })
                            .catch((e) => console.log(e));
                    }}>
									<i className="ri-delete-bin-5-fill fs-16"></i>
								</div>
							</div>
						</div>);
            }
        },
    ], []);
    // const [modal, setModal] = useState(false);
    // const toggle = useCallback(() => {
    //   if (modal) {
    //     setModal(false);
    //     setCheckedRecords([]);
    //   } else {
    //     setModal(true);
    //   }
    // }, [modal]);
    const clearSelectedOptions = () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        const checkall = document.getElementById("checkBoxAll");
        ele.forEach((element) => {
            element.checked = false;
        });
        checkall.checked = false;
        setFocusState(-1);
    };
    const deleteRecords = () => {
        // (async () => {
        // 	for (let i = 0; i < checkedRecords.length; i++) {
        // 		const record = checkedRecords[i];
        // 		await deleteTicketItem(record.id)
        // 	}
        // 	alert("삭제 완료");
        // })().then(() => onRequestData(API_SUPPLY_ITEM_LIST)).catch((e) => console.log(e))
    };
    const refundRecords = () => {
        // (async () => {
        // 	for (let i = 0; i < checkedRecords.length; i++) {
        // 		const record = checkedRecords[i];
        // 		await refundTicketItem(record.id)
        // 	}
        // 	alert("환불 완료");
        // })().then(() => onRequestData(API_SUPPLY_ITEM_LIST)).catch((e) => console.log(e))
    };
    const changeState = () => {
        // (async () => {
        // 	if (focusState === 0) {
        // 		for (let i = 0; i < checkedRecords.length; i++) {
        // 			const record = checkedRecords[i];
        // 			if (record["상태"] === "사용안함") {
        // 				await changeTicket(record.id, "사용함")
        // 			}
        // 		}
        // 		alert("사용처리 완료");
        // 	}
        // 	else if (focusState === 1) {
        // 		for (let i = 0; i < checkedRecords.length; i++) {
        // 			const record = checkedRecords[i];
        // 			if (record["상태"] === "사용함") {
        // 				await changeTicket(record.id, "사용안함")
        // 			}
        // 		}
        // 		alert("사용취소 완료");
        // 	}
        // })().then(() => onRequestData(API_SUPPLY_ITEM_LIST)).catch((e) => console.log(e))
    };
    const changeCheckedRecords = () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        let checked = [];
        try {
            ele.forEach((element) => {
                let tmpArr = data.filter((item) => (item.id).toString() === element.value.toString());
                let obj = tmpArr[0];
                checked.push(obj);
            });
        }
        catch (error) {
            console.log(error);
        }
        // console.log("changeCheckedRecords", checked)
        setCheckedRecords(checked);
    };
    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };
    return (<React.Fragment>
			<div className="page-content">

				<Container fluid>
					<BreadCrumb title="지점발주목록" pageTitle="발주"/>
					<Row>
						<Col lg={12}>
							<Card id="customerList">
								<CardHeader className="border-0">
									<Row className="g-4 align-items-center">
										<div className="col-sm">
											<div>
												<h5 className="card-title mb-0">지점 발주 목록</h5>
											</div>
										</div>
										<div className="col-sm-auto">
											<div className="hstack gap-2">

												<span style={{ padding: "4px" }}></span>

												{/* <Button
            onClick={() => { changeCheckedRecords(); togStateChangeModal(); setFocusState(0) }}
         color="soft-secondary" className="me-1">사용처리</Button>
        <Button
            onClick={() => { changeCheckedRecords(); togStateChangeModal(); setFocusState(1) }}
         color="soft-warning" className="me-1">사용취소</Button>
        <Button
            onClick={() => { changeCheckedRecords(); togDeleteModal(); }}
         color="soft-danger" className="me-1"><i className="ri-delete-bin-2-line"></i></Button> */}
											</div>
										</div>
									</Row>
								</CardHeader>

								<div className="card-body pt-0 px-2">
									<div>
										<React.Fragment>
											<ServerPaginatedTable url={API_SUPPLY_ITEM_LIST} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} onChangeQuery={setDataQuery} categories={[
        // { id: 0, title: "전체", search: "", icon: "ri-store-2-fill" },
        // { id: 1, title: "예약완료", search: "", icon: "ri-checkbox-circle-line" },
        // { id: 2, title: "입금대기", search: "", icon: "ri-more-fill" },
        // { id: 3, title: "취소완료", search: "", icon: "ri-arrow-left-right-fill" },
        ]}/>
										</React.Fragment>
									</div>
									<Toaster position="top-center"/>
								</div>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>


			{/* Modals */}

			{/* 티켓 상태 전환 Modal */}
			<Modal id="topmodal" isOpen={stateChangeModal} onClose={() => { clearSelectedOptions(); togStateChangeModal(); }}>
				<ModalHeader className="modal-title" id="myModalLabel" toggle={() => { clearSelectedOptions(); togStateChangeModal(); }}>
					{STATE_MODAL_FOCUS[focusState]}
				</ModalHeader>
				<ModalBody className="text-center p-5">
					<div className="mt-4">
						<h6 className="mb-3">{`선택하신 사용자의 티켓을 모두 ${STATE_MODAL_FOCUS[focusState]}하시겠습니까?`}</h6>
						<p className="text-muted mb-4">{(focusState === 0) ? '"사용안함"인 티켓만 "사용함"으로 변경됩니다.' : '"사용함"인 티켓만 "사용안함"으로 변경됩니다.'}</p>
						{(checkedRecords.length > 0) ?
            <div className="live-preview" style={{ height: 200, overflowY: "scroll" }}>
									<ListGroup>
										{checkedRecords.map((record) => {
                    return (<ListGroupItem key={record.id} style={{ whiteSpace: "pre-line" }}>{`${record.id} - ${record["고객"]} - ${record["상품"]}`}</ListGroupItem>);
                })}
									</ListGroup>
								</div> :
            <span>{`${STATE_MODAL_FOCUS[focusState]}할 사용자 티켓을 먼저 선택해주세요.`}</span>}
						<br />
						<br />
						<div className="hstack gap-2 justify-content-center">
							<button className={(focusState === 0) ? "btn btn-soft-secondary fw-medium" : "btn btn-soft-warning fw-medium"} onClick={() => { clearSelectedOptions(); togStateChangeModal(); }}><i className="ri-close-line me-1 align-middle"></i> Close</button>
							<button className={(focusState === 0) ? "btn btn-secondary" : "btn btn-warning"} onClick={() => { changeState(); setStateChangeModal(false); }} disabled={checkedRecords.length === 0}>{STATE_MODAL_FOCUS[focusState]}</button>
						</div>
					</div>
				</ModalBody>
			</Modal>

			{/* Delete Modal */}
			<Modal id="topmodal" isOpen={deleteModal} onClose={() => { clearSelectedOptions(); togDeleteModal(); }}>
				<ModalHeader className="modal-title" id="myModalLabel" toggle={() => { clearSelectedOptions(); togDeleteModal(); }}>
					삭제/환불
				</ModalHeader>
				<ModalBody className="text-center p-5">
					<div className="mt-4">
						<h5 className="mb-3">선택하신 사용자의 티켓을 모두 삭제하시겠습니까?</h5>
						{(checkedRecords.length > 0) ?
            <div className="live-preview" style={{ height: 200, overflowY: "scroll" }}>
									<ListGroup>
										{checkedRecords.map((record) => {
                    return (<ListGroupItem key={record.id} style={{ whiteSpace: "pre-line" }}>{`${record.id} - ${record["고객"]} - ${record["상품"]}`}</ListGroupItem>);
                })}
									</ListGroup>
								</div> :
            <span>삭제를 원하시는 사용자 티켓을 먼저 선택해주세요.</span>}
						<br />
						<br />
						<p>티켓내역 삭제(데이터만 삭제)하는 경우 PG사(토스)에서 직접 환불 처리해주셔야 합니다.</p>
						<div className="hstack gap-2 justify-content-center">
							<Button onClick={() => { clearSelectedOptions(); togDeleteModal(); }} className="bg-gradient-light fw-medium"><i className="ri-close-line me-1 align-middle"></i> 닫기</Button>
							<Button onClick={() => { deleteRecords(); setDeleteModal(false); }} disabled={checkedRecords.length === 0} color="danger">티켓내역 삭제</Button>
							<Button onClick={() => { refundRecords(); setDeleteModal(false); }} disabled={checkedRecords.length === 0} color="danger">환불처리</Button>
						</div>
					</div>
				</ModalBody>
			</Modal>

		</React.Fragment>);
};
export default SupplyList;
